import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Tooltip, Typography } from '@mui/material';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
//
import { GridLinkButton } from 'components/common/GridLinkButton';
import { CommonStatusBadge } from 'components/common/StatusBadge';
import { RenderWLIDWarningCell } from 'components/common/DataCells';
import { isNotificationDateIsDue } from 'utils/common';
import { alertTypes } from '../../constants';

const BiddingStatusIcon = styled(FiberManualRecordIcon, {
  shouldForwardProp: (propName) => propName !== 'paused',
})(({ paused }) => ({
  verticalAlign: 'middle',
  color: paused ? 'orange' : 'green',
}));

export const getColumns = (props) => {
  return [
    {
      field: 'wlid',
      headerName: 'WLID',
      type: 'number',
      valueFormatter: (value) => Number(value || 0),
    },
    {
      field: 'platformName',
      headerName: 'Client Name',
      sortable: false,
      width: 150,
      disableClickEventBubbling: true,
      renderCell: (params) => (
        <GridLinkButton component={RouterLink} to={`/update/${params.id}`}>
          {params.value}
        </GridLinkButton>
      ),
    },
    {
      field: 'isStopBiddingUS',
      headerName: 'US',
      sortable: false,
      width: 120,
      renderCell: (params) => (
        <Tooltip title={params.row.stopReasonUS}>
          <BiddingStatusIcon paused={params.value} />
        </Tooltip>
      ),
    },
    {
      field: 'isStopBiddingEU',
      headerName: 'EU',
      sortable: false,
      width: 120,
      renderCell: (params) => (
        <Tooltip title={params.row.stopReasonEU}>
          <BiddingStatusIcon paused={params.value} />
        </Tooltip>
      ),
    },
    {
      field: 'alertDate',
      headerName: 'Payment Date',
      sortable: false,
      width: 200,
      valueGetter: (val, row) => row.alerts?.[alertTypes.payment] ?? {},
      cellClassName: ({ value }) => (!value.enabled ? 'disabled' : ''),
      valueFormatter: (value) => (value.endDate || '-').slice(0, 10),
      renderCell: ({ value, formattedValue }) => (
        <Typography
          display='inline'
          color={
            isNotificationDateIsDue(value.endDate) && !!value.enabled
              ? 'error'
              : ''
          }
          alignSelf='middle'
          variant='body2'
        >
          {formattedValue || '-'}
        </Typography>
      ),
    },
    {
      field: 'warning',
      headerName: 'Warnings',
      sortable: false,
      width: 100,
      align: 'center',
      renderCell: RenderWLIDWarningCell,
    },
    {
      field: 'firstName',
      headerName: 'Manager',
      sortable: false,
      width: 200,
      renderCell: (params) => (
        <>
          {params.row.firstName} {params.row.lastName}
        </>
      ),
    },
    { field: 'email', headerName: 'Email', sortable: false, width: 200 },
    { field: 'type', headerName: 'Type', sortable: false, width: 200 },
    { field: 'adType', headerName: 'Ad Type', sortable: false, width: 200 },
    {
      field: 'status',
      headerName: 'Status',
      disableClickEventBubbling: true,
      flex: 0,
      renderCell: (params) => <CommonStatusBadge status={params.value} />,
    },
    {
      field: 'createdAt',
      headerName: 'Registered',
      width: 200,
      valueFormatter: (value) => (value || '-').slice(0, 10),
    },
    {
      sortable: false,
      disableClickEventBubbling: true,
      headerName: '',
      field: 'actions',
      type: 'actions',
      width: 130,
      renderCell: (params) => {
        const {
          wlid,
          settings: { admin },
        } = params.row;

        const domain = admin?.panel?.domain;

        const disabled = !domain;

        return (
          <Button
            size='small'
            variant='contained'
            color='primary'
            disabled={disabled}
            onClick={() => props.handleSignIn(wlid, domain)}
            className={clsx({ disabled })}
          >
            {`Sign In as ${wlid}`}
          </Button>
        );
      },
    },
  ];
};
